export const ContactChannelPiece = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => {
  const href = label.toLowerCase() === "email" && value.includes("@") ? `mailto:${value}` : label.toLowerCase() === "phone" && /[0-9]/.test(value) ? `tel:${value}` : /^https:\/\//.test(value) ? value : null;
  return (
  <div className="rounded-md border border-white/10 bg-white/5 p-5">
    <p className="text-xs font-black uppercase text-cmj-gold">{label}</p>
    <p className="mt-3 text-lg leading-7 text-white">{href ? <a className="studio-contact-link" href={href}>{value} <span aria-hidden="true">↗</span></a> : value}</p>
  </div>
);
};

export const ContactPromptPiece = ({ prompt }: { prompt: string }) => (
  <li className="rounded-md border border-white/10 bg-white/5 px-5 py-4 text-base text-cmj-white">
    {prompt}
  </li>
);
